import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { nameRegex } from '../../../../common/constants/regexes';
import ContentInput from '../../../../common/components/ContentInput/ContentInput';
import Form from '../../../../common/components/Form/Form';
import Button from '../../../../common/components/Button/Button';
import ButtonRow from '../../../../common/components/ButtonRow/ButtonRow';
import personIcon from '../../../../assets/images/icon/person.svg';

const BtnRow = styled(ButtonRow)`
  margin-top: 65px;
`;

const validate = t => values => {
  const errors = {};
  if (!values.firstName.trim()) {
    errors.firstName = t('AC.SIGNUP.NAME.ERROR_EMPTY_FIELD');
  } else if (!nameRegex.test(values.firstName.replace(' ', ''))) {
    errors.firstName = t('AC.SIGNUP.NAME.ERROR_REGEXP');
  }
  if (!values.lastName.trim()) {
    errors.lastName = t('AC.SIGNUP.NAME.ERROR_EMPTY_FIELD');
  } else if (!nameRegex.test(values.lastName.replace(' ', ''))) {
    errors.lastName = t('AC.SIGNUP.NAME.ERROR_REGEXP');
  }
  return errors;
};

const showError = (type, formik, focused) => {
  if (formik.errors[type] && !focused) {
    return !formik.values[type].trim()
      ? formik.submitCount > 0 ? formik.errors[type] : ''
      : formik.errors[type];
  }
  return '';
};

const setFieldStatus = (type, formik, focused) => {
  const validName = nameRegex.test(formik.values[type].replace(' ', ''));
  const hasLength = formik.values[type].trim() && formik.values[type].trim().length;
  const hasBeenSubmitted = formik.submitCount > 0;
  if (!focused) {
    if ((hasLength && !validName) || (!hasLength && hasBeenSubmitted)) {
      return 'error';
    }
    if (!formik.errors[type] && hasLength) {
      return 'success';
    }
  }
  return '';
};

const SignUpNameForm = ({ firstName, lastName, handleSubmit }) => {
  const { t } = useTranslation();

  const [firstNameFocused, setFirstNameFocused] = useState(false);
  const [lastNameFocused, setLastNameFocused] = useState(false);

  const formik = useFormik({
    initialValues: {
      firstName,
      lastName
    },
    validate: validate(t),
    onSubmit: values => {
      if (!formik.errors.firstName && !formik.errors.lastName) {
        handleSubmit(values);
      }
    }
  });

  return (
    <Form onSubmit={formik.handleSubmit} noValidate>
      <ContentInput
        type="text"
        id="firstName"
        label={t('AC.SIGNUP.NAME.LABEL_FIRSTNAME')}
        iconSrc={personIcon}
        maxLength={128}
        value={formik.values.firstName}
        error={showError('firstName', formik, firstNameFocused)}
        status={setFieldStatus('firstName', formik, firstNameFocused)}
        handleChange={formik.handleChange}
        handleBlur={e => {
          formik.handleBlur(e);
          setFirstNameFocused(false);
        }}
        handleFocus={() => setFirstNameFocused(true)}
      />
      <ContentInput
        type="text"
        id="lastName"
        label={t('AC.SIGNUP.NAME.LABEL_LASTNAME')}
        maxLength={128}
        value={formik.values.lastName}
        error={showError('lastName', formik, lastNameFocused)}
        status={setFieldStatus('lastName', formik, lastNameFocused)}
        handleChange={formik.handleChange}
        handleBlur={e => {
          formik.handleBlur(e);
          setLastNameFocused(false);
        }}
        handleFocus={() => setLastNameFocused(true)}
      />
      <BtnRow>
        <Button type="submit">{t('AC.SIGNUP.NAME.BUTTON_NEXT')}</Button>
      </BtnRow>
    </Form>
  )
};

SignUpNameForm.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired
};

export default SignUpNameForm;
